<template>
    <div class="qksm qksm10">
        <h4>十、其他重要事项情况说明</h4>
        <div class="nogap">
            <p>
                <b>（一）机关运行经费支出情况</b>
                <!-- <b class="tipsText hide_pdf">(备注：指为保障行政单位（包括参照公务员法管理的事业单位）运行用于购买货物和服务的各项资金，包括办公及印刷费、邮电费、差旅费、会议费、福利费、日常维修费、专用材料及一般设备购置费、办公用房水电费、办公用房取暖费、办公用房物业管理费、公务用车运行维护费以及其他费用。若无相关支出，或为事业单位该项填0，系统自动生成“本部门无一般公共预算安排的机关运行经费支出”。）</b> -->
            </p>
            <p class="hide_pdf">
                （选择单位性质<reason type="select" classname="qksm select " name="单位性质" v-model:value="qksm['单位性质']" optionarr="请选择,行政或参公单位,事业单位"></reason>）<br />
            </p>
            <template v-if="qksm['单位性质']=='事业单位'">
                <p>本{{$parent.typeText}}无一般公共预算安排的机关运行经费支出。</p>
            </template>
            <template v-else>
                <p v-if="isPdf && num(qksm['机关运行经费']) == 0 && num(qksm['机关运行经费去年']) == 0">
                    本{{$parent.typeText}}无一般公共预算安排的机关运行经费支出。
                    <template class="hide_pdf">
                        <reason type="money" classname="qksm money" name="机关运行经费" v-model:value="qksm['机关运行经费']"></reason>
                        <reason type="money" classname="qksm money" name="机关运行经费去年" v-model:value="qksm['机关运行经费去年']"></reason>
                    </template>
                </p>
                <p v-else>
                    2021年度机关运行经费支出
                    <reason type="money" classname="qksm money" name="机关运行经费" v-model:value="qksm['机关运行经费']"></reason>万元，
                    <span class="hide_pdf">
                        （年初预算数<reason type="money" classname="qksm money beginYear" name="机关运行经费去年" v-model:value="qksm['机关运行经费去年']"></reason>万元）
                    </span>
                    <span v-if="num(qksm['机关运行经费']).toFixed(2)==num(qksm['机关运行经费去年']).toFixed(2)">
                        与2021年预算基本持平。
                    </span>
                    <span v-else>
                        比年初预算数{{growthValueText(qksm['机关运行经费'],qksm['机关运行经费去年'])}}万元，
                        <span v-if="qksm['机关运行经费去年'] != 0"> 
                            {{growthRatioText(qksm['机关运行经费'],qksm['机关运行经费去年']).replace("下降","降低")}}，
                        </span>
                        主要原因是<reason type="textarea" classname="qksm widest because" name="机关运行经费原因" v-model:value="qksm['机关运行经费原因']"></reason>
                    </span>
                </p>
            </template>
            
            <p><b>（二）政府采购支出情况</b></p>
            <p>
                2021年度政府采购支出总额
                <reason type="money" classname="qksm money" name="政府采购总计" v-model:value="obj.政府采购总计"></reason>万元，
                其中：政府采购货物支出<reason type="money" classname="qksm money" name="政府采购货物" v-model:value="obj.政府采购货物"></reason>万元、
                政府采购工程支出<reason type="money" classname="qksm money" name="政府采购工程" v-model:value="obj.政府采购工程"></reason>万元、
                政府采购服务支出<reason type="money" classname="qksm money" name="政府采购服务" v-model:value="obj.政府采购服务"></reason>万元。
                授予中小企业合同金额<reason type="money" classname="qksm money" name="中小企业合同" v-model:value="qksm['中小企业合同']"></reason>万元，
                <span v-if="num(obj.政府采购总计)!=0">占政府采购支出总额的{{calcRatio(qksm['中小企业合同'],obj.政府采购总计)}}，</span>
                其中：授予小微企业合同金额<reason type="money" classname="qksm money" name="小微企业合同" v-model:value="qksm['小微企业合同']"></reason>万元
                <span v-if="num(obj.政府采购总计)!=0">，占政府采购支出总额的{{calcRatio(qksm['小微企业合同'],obj.政府采购总计)}}</span>。
                <span v-if="obj.政府采购总计 && obj.政府采购总计 != 0">
                    <span class="hide_pdf">
                        （其中：货物采购授予中小企业合同金额<reason type="money" classname="qksm money" name="货物采购中小企业" v-model:value="qksm['货物采购中小企业']"></reason>万元，
                        工程采购授予中小企业合同金额<reason type="money" classname="qksm money" name="工程采购中小企业" v-model:value="qksm['工程采购中小企业']"></reason>万元，
                        服务采购授予中小企业合同金额<reason type="money" classname="qksm money" name="服务采购中小企业" v-model:value="qksm['服务采购中小企业']"></reason>万元）
                    </span>
                    <span v-if="num(obj.政府采购货物)!=0">货物采购授予中小企业合同金额占货物支出金额的{{calcRatio(qksm['货物采购中小企业'],obj.政府采购货物)}}</span>
                    <span v-if="num(obj.政府采购工程)!=0">{{num(obj.政府采购货物)!=0 ? '，' : ''}}工程采购授予中小企业合同金额占工程支出金额的{{calcRatio(qksm['工程采购中小企业'],obj.政府采购工程)}}</span>
                    <span v-if="num(obj.政府采购服务)!=0">{{(num(obj.政府采购货物)!=0 || num(obj.政府采购工程)!=0) ? '，' : ''}}服务采购授予中小企业合同金额占服务支出金额的{{calcRatio(qksm['服务采购中小企业'],obj.政府采购服务)}}</span>
                    {{(num(obj.政府采购货物)!=0 || num(obj.政府采购工程)!=0 || num(obj.政府采购服务)!=0) ? '。' : ''}}
                </span>
            </p>
            <p><b>（三）国有资产占用情况</b></p>
            <p>
                截至2021年12月31日，本{{$parent.typeText}}共有车辆<reason type="integer" classname="qksm integer" name="共有车辆" v-model:value="car.共有车辆"></reason>辆，
                其中，符合规定领导干部用车<reason type="integer" classname="qksm integer" name="领导用车" v-model:value="car.领导用车"></reason>辆、
                机要通信用车<reason type="integer" classname="qksm integer" name="机要通信用车" v-model:value="car.机要通信用车"></reason>辆、
                应急保障用车<reason type="integer" classname="qksm integer" name="应急保障用车" v-model:value="car.应急保障用车"></reason>辆、
                执法执勤用车<reason type="integer" classname="qksm integer" name="执法执勤用车" v-model:value="car.执法执勤用车"></reason>辆、
                特种专业技术用车<reason type="integer" classname="qksm integer" name="特种专业用车" v-model:value="car.特种专业用车"></reason>辆、
                离退休干部用车<reason type="integer" classname="qksm integer" name="离退休干部用车" v-model:value="car.离退休干部用车"></reason>辆、
                其他用车<reason type="integer" classname="qksm integer" name="其他用车" v-model:value="car.其他用车"></reason>辆
                <span v-if="num(car.其他用车)>0">
                    ，其他用车主要是
                    <reason type="textarea" classname="qksm semicolon" name="其他用车主要是" v-model:value="qksm['其他用车主要是']"></reason>
                </span>
                <span v-else>；</span>
                单位价值 50 万元以上通用设备<reason type="integer" classname="qksm integer" name="通用设备" v-model:value="qksm['通用设备']"></reason>台（套），
                单位价值 100 万元以上专用设备<reason type="integer" classname="qksm integer" name="专用设备" v-model:value="qksm['专用设备']"></reason>台（套）。
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    import { editQksm } from "@/api/index.js";
    export default {
        name: "qksm10",
        components: {
            reason,
        },
        props: {
            F03: {
                type: Object,
                default: "",
            },
        },

        data() {
            //console.log(this.F03)
            var qksm = this.$store.state.divData.qksm
            var arr = ["共有车辆", "领导用车", "机要通信用车", "应急保障用车", "执法执勤用车", "特种专业用车", "离退休干部用车", "其他用车"]
            var car = [];
            for (var i = 0; i < arr.length; i++) {
                car[arr[i]] = qksm[arr[i]]
                car[arr[i]] = this.pickOneOf(qksm[arr[i]], this.num(this.F03[arr[i]]))
            }
            if (JSON.stringify(this.F03) != "{}") {
                qksm['通用设备'] = this.pickOneOf(qksm['通用设备'], this.num(this.F03["通用设备"]))
                qksm['专用设备'] = this.pickOneOf(qksm['专用设备'], this.num(this.F03["专用设备"]))
                qksm['中小企业合同'] = this.pickOneOf(qksm['中小企业合同'], this.num(this.F03["中小企业"]))
                qksm['小微企业合同'] = this.pickOneOf(qksm['小微企业合同'], this.num(this.F03["小微企业"]))
                qksm['机关运行经费'] = this.pickOneOf(qksm['机关运行经费'], this.num(this.F03["机关运行经费"]))
                qksm['机关运行经费去年'] = this.pickOneOf(qksm['机关运行经费去年'], this.num(this.F03["机关运行经费预算"]))
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
                car: car,
                obj: {
                    政府采购总计: this.pickOneOf(qksm['政府采购总计'], this.num(this.F03['政府采购合计'])),
                    政府采购货物: this.pickOneOf(qksm['政府采购货物'], this.num(this.F03['政府采购货物'])),
                    政府采购工程: this.pickOneOf(qksm['政府采购工程'], this.num(this.F03['政府采购工程'])),
                    政府采购服务: this.pickOneOf(qksm['政府采购服务'], this.num(this.F03['政府采购服务'])),
                }
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        watch: {
            obj:{
                deep: true,
                handler: async function (newVal) {
                    if(newVal.政府采购总计 == 0){
                        if(this.qksm['货物采购中小企业'] != 0){
                            this.qksm['货物采购中小企业'] = 0
                            await this.editQksm("货物采购中小企业", 0);
                        }
                        if(this.qksm['工程采购中小企业'] != 0){
                            this.qksm['工程采购中小企业'] = 0
                            await this.editQksm("工程采购中小企业", 0);
                        }
                        if(this.qksm['服务采购中小企业'] != 0){
                            this.qksm['服务采购中小企业'] = 0
                            await this.editQksm("服务采购中小企业", 0);
                        }
                    }
                },
            }
        },
        methods: {
            async editQksm(qk, sm) {
                let form = {
                    id: this.$route.query.divid,
                    qk: qk,
                    sm: sm,
                };
                let res = await editQksm(form);
                return res
            },
            async inspect() {
                var obj = Object.values(this.obj)
                var sum = 0;
                for (var i = 1; i < obj.length; i++) {
                    sum = sum + this.num(obj[i])
                }
                if (this.num(obj[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm10", "请检查本页《十、其他重要事项情况说明（二）政府采购支出情况》中政府采购分项支出金额合计应等于政府采购支出总额。");
                } else {
                    this.remove("qksm10")
                }
                if (this.num(this.qksm['中小企业合同']) > this.num(this.obj.政府采购总计)) {
                    this.addOrSet("qksm101", "请检查本页《十、其他重要事项情况说明（二）政府采购支出情况》中填写的授予中小企业合同金额应该小于等于政府采购支出总额。");
                } else {
                    this.remove("qksm101")
                }
                if (this.num(this.qksm['小微企业合同']) > this.num(this.qksm['中小企业合同'])) {
                    this.addOrSet("qksm102", "请检查本页《十、其他重要事项情况说明（二）政府采购支出情况》中填写的授予小微企业合同金额应该小于等于填写的授予中小企业合同金额。");
                } else {
                    this.remove("qksm102")
                }
                var arr = Object.values(this.car)
                sum = 0;
                for (var i = 1; i < arr.length; i++) {
                    sum = sum + this.num(arr[i])
                }
                if (this.num(arr[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm103", "请检查本页《十、其他重要事项情况说明（三）国有资产占用情况》中各项车辆使用情况总和应该等于共有车辆总数。");
                } else {
                    this.remove("qksm103")
                }
                if(this.num(this.qksm['中小企业合同']).toFixed(2) != this.num(this.num(this.qksm['货物采购中小企业']) + this.num(this.qksm['工程采购中小企业']) + this.num(this.qksm['服务采购中小企业'])).toFixed(2)) {
                    this.addOrSet("qksm104", "请检查本页《十、其他重要事项情况说明（二）政府采购支出情况》中货物采购授予中小企业合同金额+工程采购授予中小企业合同金额+工程采购授予中小企业合同金额应等于授予中小企业合同金额。");
                } else {
                    this.remove("qksm104")
                }
                if ((this.num(this.qksm['货物采购中小企业']) > this.num(this.obj.政府采购货物)) || (this.num(this.qksm['工程采购中小企业']) > this.num(this.obj.政府采购工程)) || (this.num(this.qksm['服务采购中小企业']) > this.num(this.obj.政府采购服务))) {
                    this.addOrSet("qksm105", "请检查本页《十、其他重要事项情况说明（二）政府采购支出情况》中政府采购授予中小合同金额大类不能大于政府采购支出大类总额。");
                }  else {
                    this.remove("qksm105")
                }
            }
        }
    };
</script>
